import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatProductName',
})
export class FormatProductNamePipe implements PipeTransform {
  transform(value: string): string {
    return value
      .split('_')
      .map((word) => word.charAt(0) + word.slice(1).toLowerCase())
      .join(' ');
  }
}
